import { RootState } from 'configureStore';
import { useSelector } from 'react-redux';
import { CARRIER_COMPLIANCE_EMAIL } from '../../../constants/constants';
import {
  getCurrentUser,
  getHasBookItNowPermissions,
  hasFullAccessPermissions,
} from '../../../utilities/authUtils';
import { useGetCarrierPermissionsQuery } from '../permissionsState';
import { getHasLimitedFreightAccess } from '../utils/limitedAccess';
import { getNeedsHighwaySignup } from '../utils/highwaySignup';

export const useLimitedFreightAccess = () => {
  const currentUser = getCurrentUser();
  const carrierId = currentUser?.mcleod_carrier_id;

  const { freightPermissionsFF } = useSelector(
    (state: RootState) => state.featureFlags.flags
  );

  const { data, isFetching } = useGetCarrierPermissionsQuery(carrierId, {
    skip: !freightPermissionsFF || !carrierId,
  });

  return {
    hasLimitedAccess: getHasLimitedFreightAccess(data),
    needsHighwaySignup: getNeedsHighwaySignup(data),
    displayAccessBanner:
      getHasLimitedFreightAccess(data) || getNeedsHighwaySignup(data),
    canRequestFullAccess:
      hasFullAccessPermissions(data?.companyPermissions ?? []) &&
      !getHasBookItNowPermissions(),
    upgradeRequested:
      currentUser?.metaData?.ryanTransportationOnboarding
        ?.loadboardAccessRequested,
    isLoading: isFetching,
    contactHref: `mailto:${CARRIER_COMPLIANCE_EMAIL}?subject=Load Board Access Request ${carrierId}`,
  };
};
